module.exports = __webpack_public_path__ + "img/xmas_ac_3.6714b21.webp";